import { render, staticRenderFns } from "./PrescriptionAdmnHistory.vue?vue&type=template&id=35dedd20&"
import script from "./PrescriptionAdmnHistory.vue?vue&type=script&lang=js&"
export * from "./PrescriptionAdmnHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports